import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ChangeEmailVerifyOtp = gql`
  mutation ChangeEmailVerifyOtp($input: ChangeEmailVerifyOtpInput!) {
    changeEmailVerifyOtp(input: $input) {
      ... on ChangeEmailVerifyOtpSuccess {
        __typename
        customerInfo {
          id
          email {
            address
          }
        }
      }
      ... on ChangeEmailIncorrectOtp {
        ...error
        __typename
      }
      ... on ChangeEmailExpiredOtp {
        ...error
        __typename
      }
      ... on ChangeEmailTooManyOtpAttempts {
        ...error
        __typename
      }
      ... on ChangeEmailError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;

export default ChangeEmailVerifyOtp;
